import {
  Component,
  OnInit,
  ChangeDetectorRef,
  TemplateRef,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { NgxSpinnerService } from "ngx-spinner";
import { MasterService } from "../../master/services/master-service";
import { BsModalService } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";
import { GrievanceViewService } from "../../../shared/grievance-time-line-details/grievance-time-line-details.service";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CommonConstants } from "src/app/shared/constants";
import { DatePipe } from "@angular/common";
import { CommonHelper } from "src/app/helper/helper.component";
import { DataTableDirective } from "angular-datatables";

@Component({
  selector: "app-daily-transactions",
  templateUrl: "./daily-transactions.component.html",
  styleUrls: ["./daily-transactions.component.scss"],
  providers: [MasterService, CommonHelper, DatePipe],
})
export class DailyTransactionsComponent implements OnInit {
  dataTable: any;
  dailyTransactionData: any;
  grieveanceDetailsData: any;
  modalRef: BsModalRef;
  modalView: boolean = false;
  grievanceHistoryData: any;
  adminDashBoardForm: FormGroup;
  districtsData: any;
  stateData: any;
  beneficaryStatusDetails: (
    | { id: string; color: string; name: string; dpname: string }
    | { id: number; color: string; name: string; dpname: string }
  )[];
  startDateTime: Date = null;
  submitted: boolean = false;
  endDateTime: Date = null;
  showPickerStart = false;
  showPickerEnd = false;
  maxDate: any = new Date();
  showDateStart = true;
  showTimeStart = true;
  isDailyTransactionCountExists: boolean = false;
  closeButtonStart: any = {
    show: true,
    label: "Close Me!",
    cssClass: "btn btn-sm btn-primary",
  };
  closeButtonEnd: any = {
    show: true,
    label: "Close Me!",
    cssClass: "btn btn-sm btn-primary",
  };
  showTimeEnd = true;
  showDateEnd = true;
  data = {
    state_id: "",
    complain_id: "",
    level_id: "",
    start_date: "",
    end_date: "",
  };
  data1 = {
    district_id: "",
    complain_id: "",
    level_id: "",
    start_date: "",
    end_date: "",
  };
  levelData: any;
  state_Id = sessionStorage.getItem("stateId");
  role_Id = localStorage.getItem("roleId");
  modalTable: any;
  submit: boolean = false;
  tableDistrict: boolean = false;
  tablestate: boolean = false;
  showstate: boolean = false;
  showDistrict: boolean = false;
  dtOptions: DataTables.Settings[] = [];
  currentpage: number = 1;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;

  language: any;

  constructor(
    private masterService: MasterService,
    private chRef: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private route: Router,
    private modalService: BsModalService,
    private grievanceViewService: GrievanceViewService,
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private commonHelper: CommonHelper
  ) {}

  ngOnInit(): void {
    let apiUrl = "daily_transactions";

    this.getStates();
    if (this.role_Id == "3") {
      this.getDailyTransactionList(apiUrl, this.data1, this.language);
    } else if (this.role_Id == "1") {
      this.getDailyTransactionList(apiUrl, this.data, this.language);
    } else if (this.role_Id == "5") {
      this.getDailyTransactionList(apiUrl, this.data, this.language);
    }
    this.validationsForFilters();
    this.getDistricts(parseFloat(this.state_Id));
    this.getLevels();
  }
  getDistricts(stateId: number) {
    this.apiCalling("active_districts", stateId);
  }
  validationsForFilters() {
    this.adminDashBoardForm = this.fb.group({
      selectedDistrict: [],
      selectedState: [],
      selectedGrievanceId: [],
      selectedLevel: [],
      startDateTime: [""],
      endDateTime: [""],
      complaintId: ["", [Validators.pattern(/^FE\/\d{2}\/\d{8}\/\d{3}$/)]],
    });
  }
  get f() {
    return this.adminDashBoardForm.controls;
  }

  //Reset button // ****************
  reset() {
    this.adminDashBoardForm.reset();
  }

  /* get levels */
  getLevels() {
    this.spinner.show();
    this.masterService.getAll("active_levels").subscribe((response: any) => {
      if (response.status == 200) {
        if (response.data.levels.length > 0) {
          this.levelData = response.data.levels.map((x) => {
            return {
              id: x.levelId,
              name: x.name,
            };
          });
        } else {
          this.levelData = [];
          this.commonHelper.toasterMessageError(
            CommonConstants.levelsNotAvailable
          );
        }
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    });
  }
  languageChange(event: any) {
    this.language = event;

    if (this.language == "hn" || this.language == "en") {
      if (this.role_Id == "3") {
        this.getDailyTransactionList(
          "daily_transactions",
          this.data1,
          this.language
        );
      } else if (this.role_Id == "1") {
        this.getDailyTransactionList(
          "daily_transactions",
          this.data,
          this.language
        );
      } else if (this.role_Id == "5") {
        this.getDailyTransactionList(
          "daily_transactions",
          this.data,
          this.language
        );
      }
    }
  }
  submitReport() {
    let apiData = this.adminDashBoardForm.value;
    let districtId: any;
    let stateId: any;
    let levelId: any;
    let endDatetime: any;
    let startDatetime: any;
    let complain_id: any;

    districtId = apiData.selectedDistrict
      ? apiData.selectedDistrict.districtId
      : "";
    stateId = apiData.selectedState ? apiData.selectedState.id : "";
    levelId = apiData.selectedLevel ? apiData.selectedLevel.id : "";
    startDatetime = this.startDateTime ? this.startDateTime : "";
    endDatetime = this.endDateTime ? this.endDateTime : "";
    complain_id = apiData.complaintId ? apiData.complaintId : "";

    if (this.role_Id == "1") {
      this.data = {
        state_id: stateId,
        complain_id: complain_id,
        level_id: levelId,
        start_date: startDatetime,
        end_date: endDatetime,
      };
      this.getDailyTransactionList(
        "daily_transactions",
        this.data,
        this.language
      );
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
    } else if (this.role_Id == "3") {
      this.data1 = {
        district_id: districtId,
        complain_id: complain_id,
        level_id: levelId,
        start_date: startDatetime,
        end_date: endDatetime,
      };
      this.getDailyTransactionList(
        "daily_transactions",
        this.data1,
        this.language
      );
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
    } else if (this.role_Id == "5") {
      this.data = {
        state_id: stateId,
        complain_id: complain_id,
        level_id: levelId,
        start_date: startDatetime,
        end_date: endDatetime,
      };
      this.getDailyTransactionList(
        "daily_transactions",
        this.data,
        this.language
      );
      setTimeout(() => {
        this.dtElements.forEach((dtElement: DataTableDirective) => {
          dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
      });
    }

    this.submit = true;
    // this.getDailyTransactionList(this.language);
  }
  // function to append value in input
  onValueChange(val: any, endorstart: string) {
    if (endorstart === "startDT") {
      val = this.datepipe.transform(val, "yyyy-MM-dd");
      this.startDateTime = val;
    }
    if (endorstart === "endDT") {
      val = this.datepipe.transform(val, "yyyy-MM-dd");
      this.endDateTime = val;
    }
  }

  apiCalling(url: string, id: number) {
    try {
      this.spinner.show();
      this.masterService.getData(url + "/", id).subscribe(
        (response: any) => {
          if (response.status) {
            this.dataBinding(url, response);
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }
  dataBinding(url: string, response: any) {
    if (url === "active_districts") {
      if (response.data[0].districts.length > 0) {
        this.spinner.hide();
        this.districtsData = response.data[0].districts;
      } else {
        this.districtsData = [];
        this.spinner.hide();
      }
    }
  }
  getStates() {
    this.masterService.getAll("active_states").subscribe((response: any) => {
      if (response.status == 200) {
        this.stateData = response.data;
      }
    });
  }
  getStatus() {
    this.beneficaryStatusDetails = [
      { id: "", color: "", name: "", dpname: "All" },
      {
        id: 1,
        color: "White",
        name: "withInSevenDays",
        dpname: "Within 7 days",
      },
      { id: 2, color: "Yellow", name: "processing", dpname: "Processing" },
      {
        id: 3,
        color: "Red",
        name: "notRedressed",
        dpname: "Not Redressed within 7 days",
      },
      { id: 4, color: "Green", name: "redressed", dpname: "Redressed" },
    ];
  }

  /*getData bind table data */
  getDailyTransactionList(apiRoute: string, data: any, value: string) {
    const that = this;
    const url =
      value == "hn"
        ? "//cdn.datatables.net/plug-ins/1.10.19/i18n/Hindi.json"
        : "//cdn.datatables.net/plug-ins/1.10.19/i18n/English.json";

    if (this.submit !== true) {
      if (this.role_Id == "1") {
    
        this.tablestate = true;
        this.showstate = true;
        this.spinner.show();
        this.spinner.show();

         try {
        this.dtOptions[0] = {
          pagingType: "full_numbers",
          responsive: true,
          serverSide: true,
          processing: false,
          searching: true, // remove search bar
          destroy: true, //Add to allow the datatable to destroy
          order: [],
          language: {
            url: url,
          },

          ajax: (dataTablesParameters: any, callback) => {
            that.currentpage =
              (dataTablesParameters.start + dataTablesParameters.length) /
              dataTablesParameters.length;
            that.masterService
              .postData(
                apiRoute +
                  "?page=" +
                  dataTablesParameters.length +
                  "&currentpage=" +
                  this.currentpage,
                Object.assign(dataTablesParameters, this.data)
              )
              .subscribe(
                (response: any) => {
                  if (response) {
                    this.spinner.hide();
                    if (response.status == 200) {
                      this.isDailyTransactionCountExists = true;
                      this.dailyTransactionData = response.data;
                      this.chRef.detectChanges();
                    } else {
                      this.spinner.hide();
                      this.isDailyTransactionCountExists = false;
                      this.dailyTransactionData = [];
                      this.chRef.detectChanges();
                    }
                  }
                  callback({
                    recordsTotal: response.total,
                    recordsFiltered: response.total,
                    data: [],
                  });
                },
                (error) => {
                  this.isDailyTransactionCountExists = false;
                  this.spinner.hide();
                }
              );
          },
          columns: [],
        };
        } catch (excp) {
          this.spinner.hide();
        }
      }
      if (this.role_Id == "3") {
        this.data1 = {
          district_id: "",
          complain_id: "",
          level_id: "",
          start_date: "",
          end_date: "",
        };
        this.tableDistrict = true;
        this.showDistrict = true;
        this.spinner.show();
        try {
          this.dtOptions[0] = {
            pagingType: "full_numbers",
            responsive: true,
            serverSide: true,
            processing: false,
            searching: true, // remove search bar
            destroy: true, //Add to allow the datatable to destroy
            order: [],
            language: {
              url: url,
            },

            ajax: (dataTablesParameters: any, callback) => {
              that.currentpage =
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length;
              that.masterService
                .postData(
                  "daily_transactions" +
                    "?page=" +
                    dataTablesParameters.length +
                    "&currentpage=" +
                    this.currentpage,
                  Object.assign(dataTablesParameters, this.data)
                )
                .subscribe(
                  (response: any) => {
                    if (response) {
                      this.spinner.hide();
                      if (response.status == 200) {
                        this.dailyTransactionData = response.data;

                        this.chRef.detectChanges();
                      } else {
                        this.spinner.hide();
                        this.dailyTransactionData = [];
                        this.chRef.detectChanges();
                      }
                    }
                    callback({
                      recordsTotal: response.total,
                      recordsFiltered: response.total,
                      data: [],
                    });
                  },
                  (error) => {
                    this.spinner.hide();
                  }
                );
            },
            columns: [],
          };
        } catch (excp) {
          this.spinner.hide();
        }
      } else if (this.role_Id == "5") {
        this.data = {
          state_id: "",
          complain_id: "",
          level_id: "",
          start_date: "",
          end_date: "",
        };
        this.tablestate = true;
        this.showstate = true;
        this.spinner.show();

        try {
          this.dtOptions[0] = {
            pagingType: "full_numbers",
            responsive: true,
            serverSide: true,
            processing: false,
            searching: true, // remove search bar
            destroy: true, //Add to allow the datatable to destroy
            order: [],
            language: {
              url: url,
            },

            ajax: (dataTablesParameters: any, callback) => {
              that.currentpage =
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length;
              that.masterService
                .postData(
                  "daily_transactions" +
                    "?page=" +
                    dataTablesParameters.length +
                    "&currentpage=" +
                    this.currentpage,
                  Object.assign(dataTablesParameters, this.data)
                )
                .subscribe(
                  (response: any) => {
                    if (response) {
                      this.spinner.hide();
                      if (response.status == 200) {
                        this.isDailyTransactionCountExists = true;
                        this.dailyTransactionData = response.data;
                        this.chRef.detectChanges();
                      } else {
                        this.spinner.hide();
                        this.isDailyTransactionCountExists = false;
                        this.dailyTransactionData = [];
                        this.chRef.detectChanges();
                      }
                    }
                    callback({
                      recordsTotal: response.total,
                      recordsFiltered: response.total,
                      data: [],
                    });
                  },
                  (error) => {
                    this.isDailyTransactionCountExists = false;
                    this.spinner.hide();
                  }
                );
            },
            columns: [],
          };
        } catch (excp) {
          this.spinner.hide();
        }
      }
    }
   
  }

  /*redraw the datatable*/
  reploatingDataTable() {
    let table = $("#dataTable2").DataTable();
    table.destroy();
  }

  /*routing grievance history screen */
  viewTimeLineGrievance(id) {
    this.modalView = true;
    this.masterService.getData("grievance_history/", id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.spinner.hide();
          this.grievanceHistoryData = response.data;
          this.masterService
            .getAll("grievance/view?grievanceId=" + id)
            .subscribe((response: any) => {
              if (response.status == 200) {
                this.openViewModal();
              }
              let apiUrl = "daily_transactions";

              if (this.role_Id == "3") {
                this.getDailyTransactionList(apiUrl, this.data1, this.language);
                this.refreshdata();
              } else if (this.role_Id == "1") {
                this.getDailyTransactionList(apiUrl, this.data, this.language);
                this.refreshdata();
              } else if (this.role_Id == "5") {
                this.getDailyTransactionList(apiUrl, this.data, this.language);
                this.refreshdata();
              }
            });
        } else {
          this.spinner.hide();
          this.grievanceHistoryData = [];
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  refreshdata() {
    setTimeout(() => {
      this.dtElements.forEach((dtElement: DataTableDirective) => {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw();
        });
      });
    });
  }
  // toggle function to show datetime picker modal
  onTogglePicker(value: string) {
    if (value == "startDT") {
      if (!this.showPickerStart) {
        this.showPickerStart = true;
      }
    }
    if (value == "endDT") {
      if (!this.showPickerEnd) {
        this.showPickerEnd = true;
      }
    }
  }

  /* Function for Opening the View Model*/
  openViewModal() {
    this.grievanceViewService.open();
  }

  /* Showing the user grievance Detail Modal Popup*/
  grievanceDetailsModal(template: TemplateRef<any>, grievanceId) {
    this.masterService
      .getGrievanceDetails("grievance_details/", grievanceId)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.grieveanceDetailsData = "";

            this.grieveanceDetailsData = response.data[0];

            this.modalTable = response.data[0].transaction;
            this.masterService
              .getAll("grievance/view?grievanceId=" + grievanceId)
              .subscribe((res: any) => {
                if (res.status == 200) {
                  this.modalRef = this.modalService.show(
                    template,
                    Object.assign({}, { class: "modal-lg" })
                  );
                }
                let apiUrl = "daily_transactions";

                if (this.role_Id == "3") {
                  this.getDailyTransactionList(
                    apiUrl,
                    this.data1,
                    this.language
                  );
                  this.refreshdata();
                } else if (this.role_Id == "1") {
                  this.getDailyTransactionList(
                    apiUrl,
                    this.data,
                    this.language
                  );
                  this.refreshdata();
                } else if (this.role_Id == "5") {
                  this.getDailyTransactionList(
                    apiUrl,
                    this.data,
                    this.language
                  );
                  this.refreshdata();
                }
              });
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }
}
